import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import AuthService from '../services/AuthService';
import { auth } from '../services/api';
import * as loginActions from '../redux/login';

interface Props {
  token: string;
  login: Function;
  redirect: Function;
}

interface State {
  status: string;
}

class BillingToken extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { status: 'loading' };
  }

  componentDidMount() {
    AuthService.setToken(this.props.token);

    auth
      .oneTimeToken(this.props.token)
      .then((res: any) => {
        this.setState({ status: 'success' });
        AuthService.setToken(res.token);
        this.props.login();
        this.props.redirect();
      })
      .catch((err) => {
        this.setState({ status: 'fail' });
      });
  }

  render() {
    if (this.state.status === 'loading') {
      return <p>Logging In...</p>;
    } else if (this.state.status === 'success') {
      return <p>Logged in, opening billing...</p>;
    } else {
      return <p>Error, token not valid</p>;
    }
  }
}

const mapStateToProps = (state: any) => {};

function mapDispatchToProps(dispatch: Function) {
  return {
    redirect: () => dispatch(push('/billing')),
    login: () => dispatch(loginActions.receiveLogin()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingToken);
